import { ChevronDown } from 'baseui/icon';
import { string2money } from 'common/utils/string';
import Separator from 'components/common/separator';
import { Form } from 'components/elements';
import { IconButton } from 'components/elements/buttons';
import Text from 'components/elements/text';
import useDrawer from 'hooks/use-drawer';
import { SummaryContent, SummaryLeftContainer } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';

import SummaryDrawer from './drawer';
import useRecalculate from '../hooks/use-recalculate';

interface Props {}

export default function SummaryHotelReschedule(props: Props) {
  const { t } = useTranslation();
  const drawer = useDrawer();
  const methods = useFormContext();
  const total = useRecalculate();

  const onOpenSummary = () => {
    drawer.showCustom({
      backdropClose: true,
      render: (onClose) => (
        <Form methods={methods} onSubmit={() => {}}>
          <SummaryDrawer onClose={onClose} />
        </Form>
      ),
    });
  };

  return (
    <SummaryContent>
      <SummaryLeftContainer>
        <Text variant={{ initial: 'LabelSmall', md: 'LabelLarge' }}>
          {t('common:total_sales')}:
        </Text>
        <Separator gap={16} direction="horizontal">
          <Text
            variant={{ initial: 'HeadingXSmall', md: 'HeadingSmall' }}
          >{`Rp. ${string2money(total)}`}</Text>
        </Separator>
        <IconButton buttonType="tertiary" onClick={onOpenSummary}>
          <ChevronDown size={24} />
        </IconButton>
      </SummaryLeftContainer>
    </SummaryContent>
  );
}
